import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Tooltip,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

// Static data for user groups
const staticUserGroupData = [
  { id: 1, userGroupName: 'Administrators' },
  { id: 2, userGroupName: 'Editors' },
  { id: 3, userGroupName: 'Viewers' },
  { id: 4, userGroupName: 'Contributors' },
  { id: 5, userGroupName: 'Subscribers' },
  { id: 6, userGroupName: 'Guests' },
];

const EditUserGroup = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [userGroupName, setUserGroupName] = useState('');
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    // Simulate fetching data for the specific user group using the id
    const userGroupToEdit = staticUserGroupData.find(userGroup => userGroup.id === parseInt(id));
    if (userGroupToEdit) {
      setUserGroupName(userGroupToEdit.userGroupName);
    }
  }, [id]);

  const handleSave = (e) => {
    e.preventDefault();
    if (userGroupName) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit User Group
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <TextField
            label="User Group Name"
            variant="outlined"
            fullWidth
            value={userGroupName}
            onChange={(e) => setUserGroupName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!userGroupName ? "Enter User Group Name" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!userGroupName}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              User Group Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              User Group Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditUserGroup;
